export default {
    router: {
        dashboard: "dashboard"
    }
}